(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeSidebar', PropriedadeSidebar);

  PropriedadeSidebar.$inject = ['$timeout', '$routeParams', '$rootScope'];

  function PropriedadeSidebar($timeout, $routeParams, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        sidebar: '=',
        data: '<',
        sharedData: '<'
      },
      templateUrl: 'views/propriedade/propriedade-sidebar.html',
      link(scope) {
        scope.disableInHistory = function() {
          return !!$routeParams.historyDate;
        };

        const unwatchExibirPainel = $rootScope.$watch('exibirPainelErrosIntegracao', (value) => {
          scope.exibirPainelErrosIntegracao = value;
        });
        scope.$on('$destroy', unwatchExibirPainel);

        scope.$watch('sidebar', () => {
          $timeout(() => scope.$broadcast(scope.sidebar));
        });
      }
    };
  }
}());
